import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ReservationBar from 'app/components/ReservationBar/ReservationBar';

import { Clients } from 'app/enums/clients';
import { OrderType } from 'app/enums/order-types';
import { condClass } from 'app/utils/general';
import classes from './HomeReservation.module.scss';
import { ByLineForm } from 'app/components/ReservationBar/ByLine/ByLine.model';
import { DestinationForm } from 'app/components/ReservationBar/ByDestination/ByDestination.model';
import { useLocation } from 'react-router-dom';
import { IShuttle } from 'app/models/shuttle';
import { HeaderType, UIState } from './HomeReservation.model';
import MButton from 'app/ui/MButton/MButton';

interface Props {
  uiState: UIState;
  client: Clients | null;
  supplier: string | null;
  titleShadow: boolean;
  titleColor: 'white' | 'black';
  onOpenLink: () => void;
  onSubmitLine: (values: ByLineForm, shuttleType: 'simple' | 'fixable', shuttle: IShuttle) => void;
  onSubmitDestination: (values: DestinationForm, orderType: OrderType | null) => void;
}

const HomeReservationView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  const location = useLocation();

  const supplier = useMemo(() => {
    return new URLSearchParams(location.search).get('supplier');
  }, [location]);

  return (
    <div
      className={condClass({
        [classes['container']]: true,
        [classes['container--center']]: props.uiState.headerType === HeaderType.Big,
      })}
    >
      {props.uiState.headerType === HeaderType.Big ? (
        <React.Fragment>
          <h1
            className={condClass({
              [classes['title']]: true,
              [classes['title--colorWhite']]: props.titleColor === 'white',
              [classes['title--shadow']]: props.titleShadow,
            })}
          >
            {`${t(`${props.client}.home.title`)} ${props.client === Clients.Taxelco ? supplier?.toLocaleUpperCase() : ''}`}
          </h1>
          <h2
            className={condClass({
              [classes['subTitle']]: true,
              [classes['subTitle--colorWhite']]: props.titleColor === 'white',
              [classes['subTitle--shadow']]: props.titleShadow,
            })}
          >
            {t(`${props.client}.home.subTitle`)}
          </h2>
        </React.Fragment>
      ) : (
        <div className={classes['content']}>
          <div className={classes['simpleTitle']}>
            <span className={classes['simpleTitle__text']}>{t(`${props.client}.home.suppliers.${props.supplier}`)}</span>
          </div>
          {props.supplier?.toLocaleLowerCase() === 'stl' ? (
            <MButton type="button" className={classes['btnLink']} onClick={props.onOpenLink}>{t('home.btnLinkText')}</MButton>
          ) : null}
        </div>
      )}

      {supplier?.toLocaleLowerCase() === 'exo' ?
        <div className={classes['scrollContainer']}>
          <span className={classes['scrollContainer__text']}>{t('home.exoNote')}</span>
        </div>
        : null}

      <ReservationBar
        className={classes['reservationBar']}
        onSubmitLine={props.onSubmitLine}
        onSubmitDestination={props.onSubmitDestination}
      ></ReservationBar>
    </div>
  );
};

HomeReservationView.displayName = 'HomeReservationView';
HomeReservationView.defaultProps = {};

export default HomeReservationView;
